import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allProducts } from 'app/mocks/data/catalogue/products'
import { allOrders } from 'app/mocks/data/operations/orders'

import { api } from 'app/utils/constants'

import { Order, PrepareOrderPayload } from 'app/types/operations/order'

export const updateOrderInPreparation = http.post(
    `${process.env.REACT_APP_API_ADDRESS}/${api.operations.orders.PREPARATION}`,
    async ({ request, params }) => {
        const { id } = params

        const payload = await request.json()
        const payloadParsed = PrepareOrderPayload.safeParse(payload)

        // Wrong payload
        if (!payloadParsed.success) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        const orderFound = allOrders.find((order) => order.id.toString() === id)

        // Not found
        if (!orderFound) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        return HttpResponse.json<Order>({
            ...payloadParsed.data,
            articles: payloadParsed.data.articles.map((article) => ({
                ...article,
                product: allProducts.find(
                    (product) => product.id === article.product,
                ),
            })),
        })
    },
)
